import { render, staticRenderFns } from "./ContractChangeDetail.vue?vue&type=template&id=01873275&scoped=true"
import script from "./ContractChangeDetail.vue?vue&type=script&lang=js"
export * from "./ContractChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ContractChangeDetail.vue?vue&type=style&index=0&id=01873275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01873275",
  null
  
)

export default component.exports